export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile.2541093f.webp";